// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import SettingsIcon from '@mui/icons-material/Settings';
import EditIcon from '@mui/icons-material/Edit';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import ScaleIcon from '@mui/icons-material/Scale';
import HouseSidingIcon from '@mui/icons-material/HouseSiding';
import ReceiptIcon from '@mui/icons-material/Receipt';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const icoMenu = {
    SettingsIcon,
    EditIcon,
    SettingsApplicationsIcon,
    LocalAtmIcon,
    ScaleIcon,
    HouseSidingIcon,
    ReceiptIcon
}

// ==============================|| COMPANIA MENU ITEMS ||============================== //

const compania = {
    id: 'compania',
    title: '',
    type: 'group',
    children: [
        {
            id: 'parametrosMainMenu',
            title: 'Parámetros Compañía',
            type: 'collapse',
            icon: icoMenu.SettingsIcon,
            children: [
                {
                    id: 'editar_compania',
                    title: 'Editar Compañía',
                    type: 'item',
                    icon: icoMenu.EditIcon,
                    url: '/user/edit-company'
                },
                {
                    id: 'parametros_contables',
                    title: 'Parámetros Contables',
                    type: 'collapse',
                    icon: icoMenu.SettingsApplicationsIcon,
                    children: [
                        {
                            id: 'lista_configuraciones',
                            title: 'Lista Configuraciones',
                            type: 'item',
                            url: '/user/list-config-contable-view'
                        },
                    ]
                },
                {
                    id: 'impuestos',
                    title: 'Impuestos',
                    type: 'collapse',
                    icon: icoMenu.LocalAtmIcon,
                    children: [
                        {
                            id: 'nuevo_tipo_iva',
                            title: 'Nuevo Tipo IVA',
                            type: 'item',
                            url: '/user/new-tipos_iva/0'
                        },
                        {
                            id: 'lista_tipo_iva',
                            title: 'Lista Tipo IVA',
                            type: 'item',
                            url: '/user/list-tipos_iva'
                        },
                        {
                            id: 'nuevo_codigo_ice',
                            title: 'Nuevo Código ICE',
                            type: 'item',
                            url: '/user/new-codes-ice/0'
                        },
                        {
                            id: 'lista_codigo_ice',
                            title: 'Lista Código ICE',
                            type: 'item',
                            url: '/user/list-codes-ice'
                        },
                        {
                            id: 'nuevo_codigo_retenciones',
                            title: 'Nuevo Código Retenciones',
                            type: 'item',
                            url: '/user/new-codigo-retenciones/0'
                        },
                        {
                            id: 'lista_codigo_retenciones',
                            title: 'Lista Código Retenciones',
                            type: 'item',
                            url: '/user/list-codigo-retenciones'
                        },
                        {
                            id: 'nuevo_impuesto_personalizado',
                            title: 'Nuevo Impuesto Personalizado',
                            type: 'item',
                            url: '/user/new-impuestos-personalizados/0'
                        },
                        {
                            id: 'lista_impuesto_personalizado',
                            title: 'Lista Impuesto Personalizado',
                            type: 'item',
                            url: '/user/list-impuestos-personalizados'
                        },
                    ]
                },        
                {
                    id: 'unidades_medida',
                    title: 'Unidades de Medida',
                    type: 'collapse',
                    icon: icoMenu.ScaleIcon,
                    children: [
                        {
                            id: 'nueva_unidad_medida',
                            title: 'Nueva Unidad Medida',
                            type: 'item',
                            url: '/user/new-unidad-medida/0'
                        },
                        {
                            id: 'lista_unidad_medida',
                            title: 'Lista Unidad Medida',
                            type: 'item',
                            url: '/user/list-unidad-medida-view'
                        },
                    ]
                },
                {
                    id: 'establecimientos',
                    title: 'Establecimientos',
                    type: 'collapse',
                    icon: icoMenu.HouseSidingIcon,
                    children: [
                        {
                            id: 'nueva_sucursal',
                            title: 'Nueva Sucursal',
                            type: 'item',
                            url: '/user/new-sucursales/0'
                        },
                        {
                            id: 'lista_sucursales',
                            title: 'Lista Sucursales',
                            type: 'item',
                            url: '/user/list-sucursales-view'
                        },
                        {
                            id: 'nuevo_punto_emision',
                            title: 'Nuevo Punto Emisión',
                            type: 'item',
                            url: '/user/new-punto-emision/0'
                        },
                        {
                            id: 'lista_puntos_emision',
                            title: 'Lista Punto Emisión',
                            type: 'item',
                            url: '/user/list-punto-emision-view'
                        },
                        {
                            id: 'nueva_bodega',
                            title: 'Nueva Bodega',
                            type: 'item',
                            url: '/user/new-warehouse-view/0'
                        },
                        {
                            id: 'lista_bodegas',
                            title: 'Lista Bodegas',
                            type: 'item',
                            url: '/user/list-warehouse-view'
                        },
                    ]
                },
                {
                    id: 'facturacion',
                    title: 'Facturación',
                    type: 'collapse',
                    icon: icoMenu.ReceiptIcon,
                    children: [
                        {
                            id: 'configuracion_facturacion_electronica',
                            title: 'Configuración Facturación Electrónica',
                            type: 'item',
                            url: '/user/facturacion-electronica'
                        },
                        {
                            id: 'nuevo_comprobante_electronico',
                            title: 'Nuevo Comprobante Electrónico',
                            type: 'item',
                            url: '/user/new-secuenciales/0'
                        },
                        {
                            id: 'lista_comprobante_electronico',
                            title: 'Lista Comprobante Electrónico',
                            type: 'item',
                            url: '/user/list-secuenciales-view'
                        },
                    ]
                },
                {
                    id: 'plan_de_cuentas',
                    title: 'Plan de Cuentas',
                    type: 'collapse',
                    icon: icons.IconBasket,
                    children: [
                        {
                            id: 'nueva_cuenta_clase_1',
                            title: 'Cuenta Clase 1',
                            type: 'item',
                            url: '/user/new-account-class1/0',
                            breadcrumbs: false
                        },
                        {
                            id: 'list_cuenta_clase_1',
                            title: 'Lista Cuenta 1',
                            type: 'item',
                            url: '/user/list-account-class1',
                            breadcrumbs: false
                        },                
                        {
                            id: 'nueva_cuenta_clase_2',
                            title: 'Cuenta Clase 2',
                            type: 'item',
                            url: '/user/new-account-class2/0',
                            breadcrumbs: false
                        },
                        {
                            id: 'list_cuenta_clase_2',
                            title: 'Lista Cuenta 2',
                            type: 'item',
                            url: '/user/list-account-class2',
                            breadcrumbs: false
                        },                
                        {
                            id: 'nueva_cuenta_clase_3',
                            title: 'Cuenta Clase 3',
                            type: 'item',
                            url: '/user/new-account-class3/0',
                            breadcrumbs: false
                        },
                        {
                            id: 'list_cuenta_clase_3',
                            title: 'Lista Cuenta 3',
                            type: 'item',
                            url: '/user/list-account-class3',
                            breadcrumbs: false
                        },                
                        {
                            id: 'nueva_cuenta_clase_4',
                            title: 'Cuenta Clase 4',
                            type: 'item',
                            url: '/user/new-account-class4/0',
                            breadcrumbs: false
                        },
                        {
                            id: 'list_cuenta_clase_4',
                            title: 'Lista Cuenta 4',
                            type: 'item',
                            url: '/user/list-account-class4',
                            breadcrumbs: false
                        },
                        {
                            id: 'nueva_cuenta_clase_5',
                            title: 'Cuenta Clase 5',
                            type: 'item',
                            url: '/user/new-account-class5/0',
                            breadcrumbs: false
                        },
                        {
                            id: 'list_cuenta_clase_5',
                            title: 'Lista Cuenta 5',
                            type: 'item',
                            url: '/user/list-account-class5',
                            breadcrumbs: false
                        },
                        {
                            id: 'lista_todo_plan_cuentas',
                            title: 'Lista Plan de Cuentas',
                            type: 'item',
                            url: '/user/list-all-plan-account',
                            breadcrumbs: false
                        },
                    ]
                },
                {
                    id: 'usuarios',
                    title: 'Usuarios',
                    type: 'collapse',
                    icon: icons.IconUserCheck,
                    children: [
                        {
                            id: 'lista_usuarios',
                            title: 'Lista Usuarios',
                            type: 'item',
                            url: '/user/list-user-admin'
                        },
                        {
                            id: 'nuevo_usuario',
                            title: 'Nuevo Usuario',
                            type: 'item',
                            url: '/user/new-user/0'
                        },                
                    ]
                },
                {
                    id: 'formas_pago_personalizado',
                    title: 'Pagos Personalizados',
                    type: 'collapse',
                    icon: icoMenu.ScaleIcon,
                    children: [
                        {
                            id: 'forma_pago_personalizado',
                            title: 'Nuevo Pago Personalizado',
                            type: 'item',
                            url: '/user/new-pago-personalizado/0'
                        },
                        {
                            id: 'lista_forma_pago_personalizado',
                            title: 'Lista Pago Personalizado',
                            type: 'item',
                            url: '/user/list-pago-personalizado-view'
                        },
                    ]
                },
                {
                    id: 'reportes_administracion',
                    title: 'Reportes Administración',
                    type: 'collapse',
                    icon: icons.IconNfc,
                    children: [
                        {
                            id: 'lista_reportes_administracion',
                            title: 'Lista Reportes',
                            type: 'item',
                            url: '/user/list-reportes-administracion'
                        },
                    ]
                },
            ]
        }
    ]
};

export default compania;
